import React from 'react';
import ReactFileReader from 'react-file-reader';
import Modal from 'react-modal';
import {connect} from "react-redux";
import moment from 'moment';
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as AdminActions from "../../../../actions/admin"
import config from "../../../../../../server/src/config";
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../../reusable/UserFieldElement";

class RestoreFromBackupDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            year: '',
        }
    }

    fields = [];
    render() {
        const fileExtentions = [...Array(100).keys()].map(i => '.' + String(i).padStart(2, '0'));
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {this.props.onClose()}}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content : {
                        height: this.props.auth.database === 'standard' ? '320px' : '400px',
                        width: '500px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Indlæs fra backup</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <form id="restore-backup-form" action={"/api/admin/restore-backup"} method="post" enctype="multipart/form-data">
                                <input type="file" accept=".zip,.sql" id="backup-file-selecctbackup" name="backup-file-selecctbackup" caption="Vælg fil" style={{display: 'none'}} onChange={this.onFileSelect} />
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{width: '125px'}}>
                                                <button className="btn-primary" onClick={e => {
                                                    e.preventDefault();
                                                    document.getElementById("backup-file-selecctbackup").click();
                                                }}>Vælg fil</button>
                                            </td>
                                            {this.state.file === null ? null : <td style={{paddingLeft: '10px'}}>
                                                <div>{this.state.file.name}</div>
                                                <div style={{fontSize: '.8em'}}>{moment(this.state.file.lastModifiedDate).format(config.formats.dateTimeFormat)}, {this.state.file.size} bytes</div>
                                            </td>}
                                        </tr>
                                        <tr>
                                            <td style={{width: '125px', paddingTop: '10px', verticalAlign: 'top'}}>
                                                <label htmlFor="year">År</label>
                                            </td>
                                            <td>
                                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="Aktuelt" className="field100" containerClassName="display-inline-block"
                                                                  name="year" id="year" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{4}"}]} value={this.state.year}
                                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                  onChange={this.onStandardFieldChange}
                                                                  onBlur={() => {
                                                                      this.fields[0].setState({focused: false, visited: true});
                                                                      if (/^[0-9]{2}$/.test(this.state.year)) this.setState({year: '20' + this.state.year});
                                                                  }}
                                                                  ref={instance => { this.fields[0] = instance; }}
                                                />
                                                <p style={{fontSize: '.75em', marginTop: '5px', marginBottom: '0'}}>Indtast et årstal for at oprette en ny database for det angivne år. Dette vil ikke ændre den aktuelle database.</p>
                                                <p style={{fontSize: '.75em', marginTop: '10px', marginBottom: '0'}}>Dette kan specielt være nyttigt i forbindelse med sæsonstart. Før sæsonstart anbefales det at tage en backup af databasen. Indlæses denne backup til det relevante årstal, vil det siden være muligt at skifte til arkivdatabasen for at tilgå data fra tidligere sæsoner.</p>
                                            </td>
                                        </tr>
                                        {this.props.auth.database === 'standard' ? null : <tr className="warning-information">
                                            <td colSpan={2} style={{paddingTop: '10px'}}>
                                                Du har i øjeblikket åbnet en arkivdatabase. Hvis du indlæser backup uden angivelse af årstal, vil du overskrive <b>arkivdatabasen</b>. For at gendanne den primære database fra en backup, skal du først returnere til standarddatabasen.
                                            </td>
                                        </tr>}
                                    </tbody>
                                </table>
                                {/*<ReactFileReader id="backup-file" name="backup-file" fileTypes={['.zip', '.sql']} base64={false} multipleFiles={false} handleFiles={this.onFileSelect}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td><button onClick={e => e.preventDefault()} className="btn-primary">Vælg filer</button></td>
                                                {this.state.file === null ? null : <td style={{paddingLeft: '10px'}}>
                                                    <div>{this.state.file.name}</div>
                                                    <div style={{fontSize: '.8em'}}>{moment(this.state.file.lastModifiedDate).format(config.formats.dateTimeFormat)}, {this.state.file.size} bytes</div>
                                                </td>}
                                            </tr>
                                        </tbody>
                                    </table>
                                </ReactFileReader>*/}
                            </form>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-dangerous" disabled={this.state.file === null} onClick={this.onRestore} title="Ved indlæsning af backup overskrives ALLE data i den eksisterende database.">Indlæs backup</button>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onFileSelect = (file) => {
        const filelist = document.getElementById("backup-file-selecctbackup").files;
        if (filelist.length > 0) {
            if (/^.+\.SQL$/.test(filelist[0].name.toUpperCase()) || /^.+\.ZIP$/.test(filelist[0].name.toUpperCase())) this.setState({file: filelist[0]});
            else NotificationManager.error("Kun filer af typen .ZIP og .SQL kan bruges til at indlæse fra backup.", "Ugyldigt tiltype", 10000);
        }
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    onRestore = () => {
        if (this.allInputValid()) {
            if (this.state.file !== null) document.getElementById('restore-backup-form').submit();
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };
}

const mapStateToProps = (state) => ({
    auth: {
        database: state.auth.database,
    },
});

export default connect(mapStateToProps)(RestoreFromBackupDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/RestoreFromBackupDialog.js